import { render, staticRenderFns } from "./BottomTagContent.vue?vue&type=template&id=209f1556&"
import script from "./BottomTagContent.vue?vue&type=script&lang=js&"
export * from "./BottomTagContent.vue?vue&type=script&lang=js&"
import style0 from "./BottomTagContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports